import type * as Banner from '../types/Banner'
import { imageParser } from '../props/parsers/Image'

export default function bannerComponentParser(
  rawComponent: Banner.Raw,
): Banner.Parsed {
  const { image, ...rest } = rawComponent.banner

  let updatedProps = rest

  if (image) {
    updatedProps = {
      ...rest,
      ...imageParser(image),
    }
  }

  return {
    name: 'Banner',
    props: updatedProps,
  }
}
